import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  duration: {
    '& > *': {
      maxWidth: 124,
      '& > label': { overflow: 'initial' },
    },
  },
  usage: {
    '& > *': {
      '& > label': { overflow: 'initial' },
    },
  },
  requestedColumn: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

export default styles;
